export default __webpack_public_path__ + "static/media/PeopleFlow_background.797cd609.png";